// @flow
import { memo, useEffect } from 'react'
import { useStore } from 'effector-react'
import { Phone as UiPhone } from '@foxford/ui/es/components/Phone/Phone'

import { $phones } from './model/store'
import { fetchPhones, fetchRequest } from './model/events'

type Props = {|
  number?: string,
  className?: string,
  isCompact?: boolean,
  isWhite?: boolean,
  size?: string,
|}

export const ContactPhoneStored = memo<Props>(function ContactPhoneStored({ number, ...rest }: Props) {
  const phones = useStore($phones)
  const pending = useStore(fetchRequest.pending)

  useEffect(() => {
    fetchPhones()
  }, [])

  if (phones === null || pending) {
    // TODO: сделать UI компонент с плэйсхолдером на загрузку
    return <UiPhone phoneNumber='' {...rest} />
  }

  return <UiPhone phoneNumber={`${phones.contactPhoneNumber}`} {...rest} />
})

// eslint-disable-next-line prefer-arrow-callback
export const ContactPhone = memo<Props>(function ContactPhone({ number, ...rest }: Props) {
  if (number !== null && number !== undefined && number !== '') {
    return <UiPhone phoneNumber={`${number}`} {...rest} />
  }

  return <ContactPhoneStored {...rest} />
})
